import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsmodal',
	templateUrl:'./BSModalPage.html',
	styles: [],
	styleUrls:['./BSModalPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSModalPage
{
	mdContent_127 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.modal.BSModal;
\`\`\``;
	mdContent_128 = `\`\`\`java
new BSModal<>()
\`\`\``;
	mdContent_129 = `\`\`\`java
var modal = new BSModal<>();
modal.getModalHeader().addTitle("Confirm");
modal.getModalBody().setText("Are you sure?");

var footer = modal.getModalFooter();
var closeBtn = new BSButton<>("Close");
modal.setCloseButton(closeBtn);
footer.add(closeBtn);

// Wire an open button
var openBtn = new BSButton<>("Open Modal");
modal.setOpenButton(openBtn);
\`\`\``;
}
